import { useCallback, useEffect } from 'react';

import { useAppDispatch } from '@verantos-dev/app-state-base';
import { updateAVProgress } from '@verantos-dev/app-state-research-assistant';
import type {
  AVProgressAction,
  AVProgressItem,
  AVProgressStatus,
} from '@verantos-dev/types-common';

import { useResearchAssistantSocketContext } from '../../contexts/ResearchAssistantSocketContext';

interface AVProgressPayload {
  av_index: number;
  name: string;
  action: AVProgressAction;
  status: AVProgressStatus;
  retry_message?: string;
  total_count: number;
}

export const useAVProgressListeners = () => {
  const dispatch = useAppDispatch();
  const { socket: currentSocket } = useResearchAssistantSocketContext();

  const avProgressHandler = useCallback(
    (data: AVProgressPayload) => {
      if (data?.av_index === undefined || !data?.status) return;

      const item: AVProgressItem = {
        avIndex: data.av_index,
        name: data.name,
        action: data.action,
        status: data.status,
        retryMessage: data.retry_message,
      };

      dispatch(updateAVProgress(item));
    },
    [dispatch]
  );

  useEffect(() => {
    if (currentSocket) {
      currentSocket.on('av_progress', avProgressHandler);
    }

    return () => {
      if (currentSocket) {
        currentSocket.off('av_progress', avProgressHandler);
      }
    };
  }, [avProgressHandler, currentSocket]);
};
